var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowDrillingSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "icon-white",
    points: "27.21 15.8 27.21 11.11 22.91 11.11 22.91 15.65 22.59 15.64 7.01 24.85 7.01 30.02 25.06 40.44 42.99 30.09 42.99 24.91 27.21 15.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "m43.14,24.64l-16.25-9.38v.72l15.47,8.93-17.3,9.99L7.64,24.85l15.58-8.99v-.72L6.86,24.57c-.1.06-.16.16-.16.27v5.18c0,.11.06.21.16.27l18.04,10.42s.1.04.16.04.11-.01.16-.04l17.93-10.35c.1-.06.16-.16.16-.27v-5.18c0-.11-.06-.21-.16-.27Zm-18.4,15.26L7.33,29.84v-4.45l17.42,10.06v4.45Zm17.93-9.99l-17.3,9.99v-4.45l17.3-9.99v4.45Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-highlight",
    d: "m27.21,5.7c-.23,0-.42.19-.42.42v3.12c0,.23.19.42.42.42s.42-.19.42-.42v-3.12c0-.23-.19-.42-.42-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-highlight",
    d: "m27.21,10.73c-.21,0-.38.17-.38.38v11.25l-1.34,4.05c-.28-.05-.58-.06-.87-.02l-1.33-4.03v-11.25c0-.21-.17-.38-.38-.38s-.38.17-.38.38v11.31s0,.08.02.12l1.34,4.05c-.06.03-.11.05-.17.08-.71.41-.7,1.07,0,1.48s1.86.41,2.56,0,.7-1.07,0-1.48c-.02-.01-.04-.02-.06-.03l1.36-4.1s.02-.08.02-.12v-11.31c0-.21-.17-.38-.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-highlight",
    d: "m22.91,9.66c.23,0,.42-.19.42-.42v-3.12c0-.23-.19-.42-.42-.42s-.42.19-.42.42v3.12c0,.23.19.42.42.42Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowDrillingSm);
export default __webpack_public_path__ + "static/media/flow_drilling_sm.0cd6d10b.svg";
export { ForwardRef as ReactComponent };